import { EAccess, EAccessMethod } from "@app/access/access.model";
import { EvideTableColumn, EvideTableColumnType, EvideTableColumnComponent } from "../common/common.model";

export interface INotificationTemplateParameterHttpResponse {
    id: number;
    notificationTemplateId: number;
    parameterName: string;
    notificationParameterTypeId: number;
}

export class NotificationTemplateParameter {
    constructor(
        public id: number,
        public notificationTemplateId: number,
        public parameterName: string,
        public notificationParameterTypeId: number
    ) { }

    public static adapt(data: INotificationTemplateParameterHttpResponse) {
        return new this(
            data.id,
            data.notificationTemplateId,
            data.parameterName,
            data.notificationParameterTypeId
        );
    }

    public static createBlank(notificationTemplateId: number) {
        return new this(0, notificationTemplateId, '', 0);
    }
}

export const NotificationTemplateParameterColumns: Readonly<EvideTableColumn[]> = [
    {
      key: 'parameterName',
      type: EvideTableColumnType.Text,
      compType: EvideTableColumnComponent.Input,
      isFormField: true,
      isFormEditableField: true,
      title: 'Parameter Name',
      displayValue: true,
      required: true,
      required_error: 'Parameter Name is Required',
    },
    {
        key: 'notificationParameterTypeId',
        type: EvideTableColumnType.Text,
        compType: EvideTableColumnComponent.Dropdown,
        isFormField: true,
        isFormEditableField: true,
        title: 'Notification Parameter Type',
        displayValue: true,
        required: true,
        required_error: 'Notification Parameter Type is Required',
        placeholder: 'Please Select Notification Parameter Type',
      }
  ];